/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum models_ActivityType {
    ActivityTypeCheckIn = 'check_in',
    ActivityTypeCheckOut = 'check_out',
    ActivityTypeToiletPee = 'toilet_pee',
    ActivityTypeToiletPoo = 'toilet_poo',
    ActivityTypeToiletNothing = 'toilet_nothing',
    ActivityTypeFeedingMilk = 'feeding_milk',
    ActivityTypeFeedingPorridge = 'feeding_porridge',
    ActivityTypeFeedingSolid = 'feeding_solid',
    ActivityTypeFeedingSnack = 'feeding_snack',
    ActivityTypeFeedingBreastmilk = 'feeding_breastmilk',
    ActivityTypeFeedingRefused = 'feeding_refused',
    ActivityTypeNapStart = 'nap_start',
    ActivityTypeNapEnd = 'nap_end',
    ActivityTypeHealthAccident = 'health_accident',
    ActivityTypeHealthIllness = 'health_illness',
    ActivityTypeHealthMedication = 'health_medication',
    ActivityTypePicture = 'picture',
    ActivityTypeOutdoor = 'outdoor',
    ActivityTypeIndoor = 'indoor',
    ActivityTypeNote = 'note',
    ActivityTypeMoodCheck = 'mood_check',
}
